import React from 'react';
import { FileText } from 'lucide-react';
import LegalPageLayout, { LegalSection } from './LegalPageLayout';

const TermsOfUsePage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  return (
    <LegalPageLayout
      title="شروط الاستخدام"
      icon={<FileText className="h-8 w-8" />}
      lastUpdated="17 يوليو 2026"
      totalItems={totalItems}
      totalFavorites={totalFavorites}
      setCurrentPage={setCurrentPage}
    >
      <LegalSection title="مقدمة">
        <p>
          يُعد استخدامك لموقع صيدلية الريان أو تطبيقنا موافقة صريحة منك على الشروط والأحكام
          الموضحة في هذه الصفحة. يُرجى قراءتها بعناية قبل إتمام أي عملية شراء أو استخدام لخدماتنا.
        </p>
      </LegalSection>

      <LegalSection title="استخدام الموقع">
        <ul className="list-inside list-disc space-y-2">
          <li>يجب أن يكون عمرك 18 عامًا فأكثر لإتمام عمليات الشراء، أو بموافقة ولي الأمر.</li>
          <li>يُمنع استخدام الموقع لأي غرض غير قانوني أو مخالف للأنظمة المعمول بها.</li>
          <li>أنت مسؤول عن دقة البيانات التي تقدّمها عند إنشاء الحساب أو الطلب.</li>
        </ul>
      </LegalSection>

      <LegalSection title="المنتجات والأسعار">
        <p>
          نبذل قصارى جهدنا لضمان دقة أوصاف المنتجات وأسعارها المعروضة، ونحتفظ بالحق في تعديل
          الأسعار أو توفر المنتجات في أي وقت دون إشعار مسبق. بعض المنتجات الدوائية قد تتطلب
          روشتة طبية سارية قبل التوصيل.
        </p>
      </LegalSection>

      <LegalSection title="الملكية الفكرية">
        <p>
          جميع المحتويات الموجودة على الموقع من نصوص وشعارات وتصاميم وصور هي ملك لصيدلية الريان،
          ولا يجوز نسخها أو إعادة نشرها دون إذن كتابي مسبق.
        </p>
      </LegalSection>

      <LegalSection title="التعديلات على الشروط">
        <p>
          يحق لصيدلية الريان تحديث هذه الشروط من وقت لآخر، وسيتم نشر أي تعديلات على هذه الصفحة
          مع تحديث تاريخ آخر تعديل. استمرارك في استخدام الموقع بعد التعديل يُعد موافقة على
          الشروط المحدثة.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default TermsOfUsePage;
